
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ExclusionMotive, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class ExclusionMotiveEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    exclusionMotive: ExclusionMotive;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getExclusionMotive()]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getExclusionMotive(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.exclusionMotive = data;
                this.onDataChanged.next(this.exclusionMotive);
                resolve(this.exclusionMotive);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('exclusionMotive/' + this.routeParams.id).subscribe((res: ExclusionMotive ) => {
                    this.exclusionMotive = res;
                    this.onDataChanged.next(this.exclusionMotive);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(exclusionMotive): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('exclusionMotive/', exclusionMotive).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(exclusionMotive): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('exclusionMotive/', exclusionMotive).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(exclusionMotive): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('exclusionMotive/' + exclusionMotive.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    checkLastModifications(): ExclusionMotive {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
